export default "__VITE_ASSET__DePS8L1w__"